import React from 'react';
import DialogContent from "@mui/material/DialogContent";
import TextField from "../../../../components/form/TextField";
import Dialog from "../../../../components/Dialog";
import SingleFieldForm from "../common/SingleFieldForm";
import * as Yup from "yup";
import { Stack } from "@mui/material";

const PriceEditionDialog: React.FC<PriceEditionDialogProps> = props => {
    return (
        <Dialog
            open={ true }
            onCloseClick={ props.onClose }
            title='Edytuj cenę dla zaznaczonych nośników'
        >
            <DialogContent sx={ { minWidth: '500px' } }>
                <Stack spacing={ 4 } pt={ 2 }>
                    <SingleFieldForm
                        fieldName='priceByAbsoluteValue'
                        schema={ Yup.number().required() }
                        onSubmit={ props.onSubmit }
                    >
                        <TextField
                            name='priceByAbsoluteValue'
                            label='Wartość w PLN'
                            helperText='Cena nie może być niższa niż koszt'
                            fullWidth
                            size='small'
                            type='number'
                            inputProps={ { min: 0 } }
                        />
                    </SingleFieldForm>
                    <SingleFieldForm
                        fieldName='priceByAddedPercent'
                        onSubmit={ props.onSubmit }
                        schema={ Yup.number().required().min(
                            1,
                            'Procent musi być większy od 0'
                        ) }
                    >
                        <TextField
                            name='priceByAddedPercent'
                            label='Marża procentowa'
                            fullWidth
                            size='small'
                            type='number'
                            inputProps={ { min: 1 } }
                        />
                    </SingleFieldForm>
                    <SingleFieldForm
                        fieldName='priceByAddedValue'
                        onSubmit={ props.onSubmit }
                        schema={ Yup.number().required().min(
                            1,
                            'Wartość musi być większa od 0'
                        ) }
                    >
                        <TextField
                            name='priceByAddedValue'
                            label='Marża kwotowa'
                            fullWidth
                            size='small'
                            type='number'
                            inputProps={ { min: 1 } }
                        />
                    </SingleFieldForm>
                </Stack>
            </DialogContent>
        </Dialog>
    );
}
export default PriceEditionDialog;

export interface PriceEditionDialogProps {
    readonly onSubmit: (value: Value) => Promise<any>;
    readonly onClose: () => any;
}

type Value =
    { priceByAbsoluteValue: number } |
    { priceByAddedPercent: number } |
    { priceByAddedValue: number };